import { FC } from 'react';
import styled from 'styled-components';
import img from './main_page.png';
import { gettext } from '@cranium/i18n';

export const LoginSlider: FC = () => {
  return (
    <SliderContainer>
      <MainInfo>
        <Welcome>
          {gettext('Welcome to')}
          <span>Tough Commerce</span>
        </Welcome>
        <Description>{gettext('One platform to connect your people, systems, and data.')}</Description>
      </MainInfo>
      <Img src={img}></Img>
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  background: #002020;
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  padding: 48px;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const Welcome = styled.h1`
  font: var(--font-semibold-30);
  color: var(--white);
  display: flex;
  align-items: center;
  gap: 8px;
  > span {
    color: rgb(21, 183, 158);
  }
`;
const MainInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
`;

const Description = styled.p`
  font: var(--font-regular-18);
  color: var(--white);
`;

const Img = styled.img`
  width: 100%;
  flex: 1;
`;
